import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { Spinner } from "../../components/States";
import { personName } from "../../../shared/people";

export function Team() {
  const [members, setMembers] = useState<Awaited<ReturnType<typeof api.dashMembers>>["items"] | null>(null);
  const [email, setEmail] = useState("");
  const [role, setRole] = useState("member");
  const [link, setLink] = useState<string | null>(null);
  const [err, setErr] = useState<string | null>(null);

  const load = () => api.dashMembers().then((r) => setMembers(r.items)).catch(() => setMembers([]));
  useEffect(() => { void load(); }, []);

  const invite = async () => {
    setErr(null);
    try {
      const { token } = await api.dashInvite(email, role);
      // No mail transport in this phase — the inviter passes the link on.
      setLink(`${location.origin}/dashboard/join?token=${token}`);
      setEmail("");
      void load();
    } catch (e) {
      setErr((e as Error).message);
    }
  };

  if (!members) return <Spinner />;

  return (
    <div className="narrow">
      <h2>Team</h2>
      <div className="table-wrap">
        <table className="table">
          <thead><tr><th>Member</th><th>Role</th><th>Status</th></tr></thead>
          <tbody>
            {members.map((m) => (
              <tr key={m.username}>
                <td>{personName({ displayName: m.display_name, username: m.username })}</td>
                <td>{m.role}</td>
                <td>{m.status}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <h3 className="section">Invite a teammate</h3>
      <div className="row gap-8">
        <input
          className="input flex-1"
          placeholder="teammate@yourcompany.com"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <select className="input" value={role} onChange={(e) => setRole(e.target.value)}>
          <option value="member">Member</option>
          <option value="editor">Editor</option>
          <option value="admin">Admin</option>
        </select>
        <button className="btn btn-primary" onClick={() => void invite()}>Invite</button>
      </div>

      {link && (
        <div className="card u-6e4e42f">
          <p className="u-ad7f18b">Send this link to your teammate — it expires in 7 days:</p>
          <pre className="mono u-3a95f43">{link}</pre>
        </div>
      )}
      {err && <p className="u-497726e">{err}</p>}
    </div>
  );
}
